const SurChargeTooltip = () => {
  return (
    <section>
      <p className="pb-3 pt-1 text-sm font-semibold leading-3">Shipping Surcharge</p>
      <p className="text-xs font-normal leading-4">
        Heavyweight and oversized items are designated with an alphabetic code in the product description. If you order
        an item with a heavyweight or oversized code, the corresponding surcharge amount below will be added to your
        standard shipping total. There may be some shipping restrictions on heavyweight and oversized delivery to AK,
        HI, and all U.S. Terr. and APO/FPO addresses.
      </p>
      <h2 className="my-3 font-semibold">Heavyweight and oversized items:</h2>
      <section className="border-2 border-b-0 border-silverGray shadow-md">
        <table className="w-full text-left">
          <thead>
            <tr>
              <th className="border-b-2 border-silverGray py-2 pl-4 text-sm">Shipping Code</th>
              <th className="border-b-2 border-silverGray py-2 pl-4 text-sm">Surcharge Amount</th>
            </tr>
          </thead>
          <tbody className="text-xs">
            {[
              { code: 'A', amount: '$10.00' },
              { code: 'B', amount: '$12.50' },
              { code: 'C', amount: '$15.00' },
              { code: 'D', amount: '$17.50' },
              { code: 'E', amount: '$20.00' },
              { code: 'F', amount: '$25.00' },
              { code: 'G', amount: '$30.00' },
              { code: 'H', amount: '$35.00' },
              { code: 'I', amount: '$40.00' },
              { code: 'J', amount: '$45.00' },
              { code: 'K', amount: '$50.00' },
              { code: 'L', amount: '$55.00' },
              { code: 'M', amount: '$60.00' },
              { code: 'N', amount: '$65.00' },
              { code: 'O', amount: '$70.00' },
              { code: 'P', amount: '$80.00' },
              { code: 'Q', amount: '$90.00' },
            ].map((item, index) => (
              <tr key={item.code} className={index % 2 != 0 ? 'bg-lightSilver' : ''}>
                <td className="border-b-2 border-silverGray px-4 py-2">{item.code}</td>
                <td className="border-b-2 border-silverGray px-4 py-2">{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </section>
  );
};

export default SurChargeTooltip;
